const {Link} = require("../../../../../../router");
const Ripple = require("../../../../../dumb/Ripple");
const React = require("react");

module.exports = ({link, backPath, disabled}) => (
  <Ripple
    component={Link}
    className={
      "layoutRow fvaC fhaC h45 wmin75 bs b1 bcC r9 ttU olN f12 fw4 tdN ov dn bc0:h ml20"
      + ' (o50).disabled (bcC|crDefault).disabled:h'
      + (disabled ? ' disabled' : '')
    }
    href={link + `?backPath=${backPath}` || '#'}
    disabled={disabled}
  >
    Add +
  </Ripple>
)
